// src/pages/MetalPage.jsx
import { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';
import { usePageMeta } from '../hooks/usePageMeta';

import AOS from 'aos';
import 'aos/dist/aos.css';

import { Swiper, SwiperSlide } from 'swiper/react';
// ВАЖНО: модули берем из 'swiper/modules' (v10+)
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const Wrap = styled.div``;

/* ---------- HERO ---------- */
const Hero = styled.section`
  padding: 80px 0 40px;
  .inner { width: ${({theme})=>theme.container}; margin: 0 auto; display: grid; gap: 24px; }
  h1 { margin-bottom: 12px; }
  .lead { font-size: 20px; color: ${({theme})=>theme.textMuted}; }
  .actions { display:flex; gap:12px; flex-wrap: wrap; margin-top: 8px; }
`;

/* ---------- BADGES ---------- */
const Badges = styled.div`
  display:flex; gap: 10px; flex-wrap: wrap; margin-top: 10px;
  .badge{
    font-size: 14px; padding: 6px 10px; border-radius: ${({theme})=>theme.radius.pill}px;
    background: ${({theme})=>theme.surface}; border: 1px solid ${({theme})=>theme.border};
  }
`;

/* ---------- CARDS GRID ---------- */
const Section = styled.section`
  padding: 64px 0;
  &.muted { background: ${({theme})=>theme.body}; }
  .inner { width: ${({theme})=>theme.container}; margin: 0 auto; }
  .head { display:flex; align-items:flex-end; justify-content:space-between; gap:16px; margin-bottom: 20px; }
  .grid{
    display:grid; gap: 16px;
    grid-template-columns: repeat(3, 1fr);
    @media (max-width: 980px){ grid-template-columns: 1fr; }
  }
  .card h3 { margin-bottom: 6px; }
  .card p { margin: 0; }
`;

const Media = styled.div`
  position: relative; overflow: hidden; border-radius: ${({theme})=>theme.radius.lg}px; border:1px solid ${({theme})=>theme.border};
  img{ width:100%; display:block; transform: scale(1.02); transition: transform .6s ease; }
  &:hover img{ transform: scale(1.06); }
`;

/* ---------- TIMELINE ---------- */
const Timeline = styled.div`
  position:relative; padding-left: 22px; display:grid; gap:16px;
  &:before{
    content:''; position:absolute; top:4px; bottom:4px; left:9px; width:2px; background: ${({theme})=>theme.border};
  }
  .step{
    position:relative; background: ${({theme})=>theme.surface}; border:1px solid ${({theme})=>theme.border};
    border-radius: ${({theme})=>theme.radius.lg}px; padding: 14px 14px 14px 18px;
  }
  .step:before{
    content:''; position:absolute; left:-13px; top:16px; width:10px; height:10px; border-radius:50%;
    background: ${({theme})=>theme.accent}; box-shadow: 0 0 0 3px rgba(255,102,0,.25);
  }
  .kicker{ font-size:12px; opacity:.65; letter-spacing:.06em; text-transform:uppercase; }
  h3{ margin:4px 0 6px; }
  p{ margin:0; }
`;

/* ---------- STATS ---------- */
const Stats = styled.div`
  display:grid; grid-template-columns: repeat(4, 1fr); gap: 12px;
  @media (max-width: 980px){ grid-template-columns: repeat(2, 1fr); }
  .stat{
    background: ${({theme})=>theme.surface}; border:1px solid ${({theme})=>theme.border};
    border-radius: ${({theme})=>theme.radius.lg}px; padding: 18px; text-align:center;
  }
  .num{ font-size: 28px; font-weight: 900; letter-spacing: -.02em; }
  .label{ font-size: 14px; color: ${({theme})=>theme.textMuted}; }
`;

/* ---------- SWIPER ---------- */
const CarouselCard = styled.div`
  background: ${({theme})=>theme.surface}; border:1px solid ${({theme})=>theme.border};
  border-radius: ${({theme})=>theme.radius.lg}px; overflow:hidden;
  .cap{ padding: 12px 14px; display:flex; align-items:center; justify-content:space-between; gap:8px; }
  .cap b{ font-size:14px; }
  img{ display:block; width:100%; height: 280px; object-fit: cover; }
  @media (max-width: 980px){ img{ height: 220px; } }
`;

/* ---------- CTA ---------- */
const CTA = styled.section`
  padding: 64px 0 90px;
  .inner{ width: ${({theme})=>theme.container}; margin:0 auto; text-align:center; }
  .panel{
    display:grid; gap:14px; justify-items:center; padding: 28px;
    border:1px solid ${({theme})=>theme.border}; border-radius: ${({theme})=>theme.radius.xl}px;
    background: linear-gradient(180deg, rgba(255,102,0,.07), transparent);
  }
  .row{ display:flex; gap:10px; flex-wrap:wrap; justify-content:center; }
`;

/* ---------- DATA ---------- */
const SERVICES = [
  { title: 'Переробка відходів металобрухту', text: 'Приймання, сортування, різання та підготовка металобрухту до переплаву з дотриманням екостандартів.', img: '/img/metal/scrap.jpg' },
  { title: 'Механічна обробка', text: 'Токарні, фрезерні, шліфувальні операції. Точні та великогабаритні деталі соосно і в допусках.', img: '/img/metal/machining.jpg' },
  { title: 'Унікальні та складні деталі', text: 'Колеса сепаратора, корпусні деталі, бандажі та вінці сушильних барабанів, валки, вали до 6м, нарізка зубців.', img: '/img/metal/unique.jpg' },
  { title: 'Автоматичне/напівавтоматичне зварювання', text: 'Наплавлення зносостійкими матеріалами, відновлення геометрії та ресурсу роботи вузлів.', img: '/img/metal/welding.jpg' },
  { title: 'Ливарний та термічний цех', text: 'Литво за моделями замовника, термообробка (гарт, відпуск, нормалізація) під властивості матеріалу.', img: '/img/metal/foundry.jpg' },
  { title: 'Малосерійне виготовлення', text: 'Вузли та деталі для машинобудівних заводів, контроль якості, маркування та упаковка.', img: '/img/metal/series.jpg' },
  { title: 'Металоконструкції', text: 'Проєкт, виготовлення та монтаж конструкцій для промислових підприємств та ангарів.', img: '/img/metal/frames.jpg' },
  { title: 'Лазерне різання та гибка', text: 'Лист до 20 мм, високий рівень точності, чистий край, гибка листового металу на верстатах з ЧПУ.', img: '/img/metal/laser-bend.jpg' },
  { title: 'Порошкове фарбування', text: 'Стійкі покриття для промислових умов: фарбувальна камера, полімеризаційна піч, підготовка поверхні.', img: '/img/metal/powder.jpg' },
];

const GALLERY = [
  { img: '/img/metal/gal1.jpg', caption: 'Виготовлення вала Ø380×5400' },
  { img: '/img/metal/gal2.jpg', caption: 'Вінець сушильного барабана' },
  { img: '/img/metal/gal3.jpg', caption: 'Реставрація редукторного корпусу' },
  { img: '/img/metal/gal4.jpg', caption: 'Наплавлення валка прокатного стану' },
  { img: '/img/metal/gal5.jpg', caption: 'Лазерне різання деталей' },
];

const ARTICLES = [
  { id: 'machining-tips', title: '5 правил стабільної механічної обробки', date: '2025-08-01' },
  { id: 'hardfacing', title: 'Що дає наплавлення зносостійкими матеріалами', date: '2025-07-14' },
  { id: 'heat-treatment', title: 'Термообробка: як підвищити ресурс деталей', date: '2025-06-10' },
];

/* ---------- COMPONENT ---------- */
export default function MetalPage() {
  const meta = usePageMeta('metal');
  useEffect(() => {
    AOS.init({ duration: 700, easing: 'ease-out-cubic', once: true, offset: 40 });
  }, []);

  return (
    <Wrap>
      <SeoMeta
        title={meta.title}
        description={meta.description}
        keywords={meta.keywords}
        image={meta.image}
        path={meta.path || '/metal'}
      />
      {/* HERO */}
      <Hero>
        <div className="inner">
          <div data-aos="fade-up">
            <h1>Металлообробка <span style={{color:'var(--accent, #ff6600)'}}>MOMV</span></h1>
            <p className="lead">
              Повний цикл: від переробки металобрухту і заготівель — до токарно-фрезерних робіт,
              термообробки, зварювання, виготовлення металоконструкцій та порошкового фарбування.
            </p>
            <Badges>
              <span className="badge">Вали до 6 м</span>
              <span className="badge">Зубонарізання (внутр./зовн.)</span>
              <span className="badge">Лазерне різання</span>
              <span className="badge">ISO-контроль якості</span>
            </Badges>
            <div className="actions">
              <Link to="/contacts" className="btn btn--primary">Отримати розрахунок</Link>
              <a className="btn btn--ghost" href="#services">Послуги</a>
            </div>
          </div>
          <Media data-aos="zoom-in" data-aos-delay="80" aria-hidden>
            <img src="/img/metal/hero.jpg" alt="Металлообробка MOMV" loading="eager" />
          </Media>
        </div>
      </Hero>

      {/* SERVICES */}
      <Section id="services" className="muted">
        <div className="inner">
          <div className="head">
            <h2 data-aos="fade-right">Наші послуги</h2>
            <Link to="/contacts" className="btn btn--ghost" data-aos="fade-left">Надіслати креслення</Link>
          </div>

          <div className="grid">
            {SERVICES.map((s, i) => (
              <article className="card" key={i} data-aos="fade-up" data-aos-delay={(i % 3) * 70}>
                <Media>
                  <img src={s.img} alt="" loading="lazy" />
                </Media>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </article>
            ))}
          </div>
        </div>
      </Section>

      {/* PROCESS / TIMELINE */}
      <Section>
        <div className="inner">
          <div className="head">
            <h2 data-aos="fade-right">Як ми працюємо</h2>
          </div>
          <Timeline>
            <div className="step" data-aos="fade-up">
              <span className="kicker">01 / Запит</span>
              <h3>Креслення та ТЗ</h3>
              <p>Приймаємо 2D/3D файли, фото, габарити. В разі потреби — виїзд інженера для заміру.</p>
            </div>
            <div className="step" data-aos="fade-up" data-aos-delay="60">
              <span className="kicker">02 / Технологія</span>
              <h3>Маршрут обробки</h3>
              <p>Підбір матеріалу та режимів різання, контрольні точки, план термообробки/наплавлення.</p>
            </div>
            <div className="step" data-aos="fade-up" data-aos-delay="110">
              <span className="kicker">03 / Виготовлення</span>
              <h3>Верстати + QC</h3>
              <p>Операції на ЧПУ/універсальних верстатах, проміжний контроль, протоколи вимірювань.</p>
            </div>
            <div className="step" data-aos="fade-up" data-aos-delay="160">
              <span className="kicker">04 / Логістика</span>
              <h3>Пакування та доставка</h3>
              <p>Тара та консервація за вимогами. Доставка автотранспортом або залізницею по Україні/ЄС.</p>
            </div>
          </Timeline>
        </div>
      </Section>

      {/* STATS */}
      <Section className="muted">
        <div className="inner">
          <Stats>
            <div className="stat" data-aos="flip-up"><div className="num">6 м</div><div className="label">Довжина валів</div></div>
            <div className="stat" data-aos="flip-up" data-aos-delay="60"><div className="num">Ø 1200</div><div className="label">Діаметр зубцювання</div></div>
            <div className="stat" data-aos="flip-up" data-aos-delay="110"><div className="num">±0.01 мм</div><div className="label">Типовий допуск</div></div>
            <div className="stat" data-aos="flip-up" data-aos-delay="160"><div className="num">24/7</div><div className="label">Виробництво</div></div>
          </Stats>
        </div>
      </Section>

      {/* GALLERY */}
      <Section>
        <div className="inner">
          <div className="head">
            <h2 data-aos="fade-right">Роботи / кейси</h2>
            <Link to="/contacts" className="btn btn--ghost" data-aos="fade-left">Замовити подібне</Link>
          </div>
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 2800, pauseOnMouseEnter: true, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            spaceBetween={12}
            slidesPerView={3}
            breakpoints={{
              0:   { slidesPerView: 1 },
              680: { slidesPerView: 2 },
              980: { slidesPerView: 3 },
            }}
          >
            {GALLERY.map((g, i) => (
              <SwiperSlide key={i}>
                <CarouselCard data-aos="zoom-in" data-aos-delay={(i % 3) * 70}>
                  <img src={g.img} alt={g.caption} loading="lazy" />
                  <div className="cap">
                    <b>{g.caption}</b>
                    <Link to="/contacts" className="btn btn--ghost" style={{padding:'6px 10px'}}>Деталі</Link>
                  </div>
                </CarouselCard>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Section>

      {/* ARTICLES PREVIEW */}
      <Section className="muted">
        <div className="inner">
          <div className="head">
            <h2 data-aos="fade-right">Статті</h2>
            <Link to="/articles" className="btn btn--ghost" data-aos="fade-left">Усі статті</Link>
          </div>
          <div className="grid">
            {ARTICLES.map((a, i) => (
              <article className="card" key={a.id} data-aos="fade-up" data-aos-delay={(i % 3) * 70}>
                <h3>{a.title}</h3>
                <p style={{marginBottom:12, fontSize:14, opacity:.7}}>
                  Опубліковано: {new Date(a.date).toLocaleDateString('uk-UA')}
                </p>
                <p>Коротко про головне — практичні поради з механічної обробки, наплавлення та термообробки.</p>
                <div style={{display:'flex', gap:8, marginTop:10}}>
                  <Link to={`/articles/${a.id}`} className="btn btn--primary">Читати</Link>
                  <Link to="/contacts" className="btn btn--ghost">Поставити запитання</Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </Section>

      {/* CTA */}
      <CTA>
        <div className="inner">
          <div className="panel" data-aos="fade-up">
            <h2>Є креслення чи зношений вузол?</h2>
            <p style={{maxWidth:680, color:'var(--muted)'}}>
              Надішліть нам дані — підготуємо маршрут обробки та прорахунок вартості.
            </p>
            <div className="row">
              <Link to="/contacts" className="btn btn--primary">Надіслати креслення</Link>
              <a className="btn btn--ghost" href="mailto:info@momv.com.ua">info@momv.com.ua</a>
            </div>
          </div>
        </div>
      </CTA>
    </Wrap>
  );
}
